<div class="px-6">
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Benutzername</th>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </thead>
    <tbody>
      @if (userLoading) {
        <tr>
          <td><ngx-skeleton-loader appearance="line" /></td>
          <td><ngx-skeleton-loader appearance="line" /></td>
          <td><ngx-skeleton-loader appearance="line" /></td>
        </tr>
      }
      @for (user of users; track user.id) {
        <tr>
          <td>{{ user.username }}</td>
          <td>{{ user.firstName }} {{ user.lastName }}</td>
          <td>
            <fino-button-row>
              <button type="button" (click)="deleteUser(user)" fino-button>
                <fino-icon icon="Bin 2" class="icon"></fino-icon>
              </button>
              <button
                type="button"
                (click)="sendPasswordMail(user)"
                fino-button
              >
                <fino-icon icon="Send Email 1" class="icon"></fino-icon>
              </button>
            </fino-button-row>
          </td>
        </tr>
      } @empty {
        @if (!userLoading) {
          <tr class="py-4">
            <td colspan="3">
              <p
                class="has-text-centered has-text-grey"
                translate="adminUsers.users.no-users"
              ></p>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>

  <div class="is-flex is-justify-content-flex-end">
    <button
      primary="true"
      type="button"
      class="has-text-weight-bold mr-1"
      (click)="downloadCSV()"
      [loading]="csvDownloading"
      fino-button
      label="adminUsers.actions.csv.download"
    ></button>

    <button
      primary="true"
      type="button"
      class="ml-1"
      (click)="addUser()"
      [loading]="addUserLoading"
      fino-button
      label="adminUsers.actions.addUser.add"
    ></button>
  </div>
</div>
